export default "__VITE_ASSET__CHwD6CIZ__"